export const PROMOTION_CREATE_REQUEST = 'PROMOTION_CREATE_REQUEST';
export const PROMOTION_CREATE_SUCCESS = 'PROMOTION_CREATE_SUCCESS';
export const PROMOTION_CREATE_FAIL = 'PROMOTION_CREATE_FAIL';
export const PROMOTION_LIST_REQUEST = 'PROMOTION_LIST_REQUEST';
export const PROMOTION_LIST_SUCCESS = 'PROMOTION_LIST_SUCCESS';
export const PROMOTION_LIST_FAIL = 'PROMOTION_LIST_FAIL';
export const PROMOTION_UPDATE_REQUEST = 'PROMOTION_UPDATE_REQUEST';
export const PROMOTION_UPDATE_SUCCESS = 'PROMOTION_UPDATE_SUCCESS';
export const PROMOTION_UPDATE_FAIL = 'PROMOTION_UPDATE_FAIL';
export const PROMOTION_DELETE_REQUEST = 'PROMOTION_DELETE_REQUEST';
export const PROMOTION_DELETE_SUCCESS = 'PROMOTION_DELETE_SUCCESS';
export const PROMOTION_DELETE_FAIL = 'PROMOTION_DELETE_FAIL';
export const PROMOTION_DETAILS_REQUEST = 'PROMOTION_DETAILS_REQUEST';
export const PROMOTION_DETAILS_SUCCESS = 'PROMOTION_DETAILS_SUCCESS';
export const PROMOTION_DETAILS_FAIL = 'PROMOTION_DETAILS_FAIL';
export const PROMOTION_STATUS_UPDATE_REQUEST = 'PROMOTION_STATUS_UPDATE_REQUEST';
export const PROMOTION_STATUS_UPDATE_SUCCESS = 'PROMOTION_STATUS_UPDATE_SUCCESS';
export const PROMOTION_STATUS_UPDATE_FAIL = 'PROMOTION_STATUS_UPDATE_FAIL';
export const PRODUCT_LIST_FOR_PROMOTION_REQUEST = 'PRODUCT_LIST_FOR_PROMOTION_REQUEST';
export const PRODUCT_LIST_FOR_PROMOTION_SUCCESS = 'PRODUCT_LIST_FOR_PROMOTION_SUCCESS';
export const PRODUCT_LIST_FOR_PROMOTION_FAIL = 'PRODUCT_LIST_FOR_PROMOTION_FAIL';
export const PROMOTION_TYPE_OPTIONS = [
  { value: 'S', label: 'Seasonal' },
  { value: 'L', label: 'Loyalty' },
  { value: 'B', label: 'Bundle' },
  { value: 'O', label: 'Other' }
];
export const DISCOUNT_TYPE_OPTIONS = [
  { value: 'P', label: 'Percentage' },
  { value: 'V', label: 'Value' },
  { value: 'F', label: 'Fixed Price' }
];